import { NoteAPI } from "api/note-api";
import { NoteForm } from "components/NoteForm/NoteForm";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addNote } from "store/note/note-slice";

export function NoteCreate(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    async function createNote(formValues) {
        const createdNote = await NoteAPI.create({
            ...formValues,
            created_at: new Date().toLocaleDateString(),
        });
        dispatch(addNote(createdNote));
        navigate("/");
    }
    return (
        <>
            <NoteForm title="Create a note" onSubmit={createNote} />
        </>
    );
}